export const SYSTEM_SANS =
  'ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif';

export const FONTS = {
  System: {
    load: async () => {
      /* system font stack — no webfont download */
    },
  },
};

export const MONOSPACE_FONTS = {
  System: {
    load: async () => {
      /* system font stack — no webfont download */
    },
  },
};

export type Fonts = keyof typeof FONTS;
export type MonospaceFonts = keyof typeof MONOSPACE_FONTS;

export const FONT_KEYS = Object.keys(FONTS).sort();
export const MONOSPACE_FONT_KEYS = Object.keys(MONOSPACE_FONTS).sort();

export const DEFAULT_FONT = "System";
export const DEFAULT_MONO_FONT = "System";
